import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  subUserId: null,
};

const SubUserSlice = createSlice({
  name: "SubUser",
  initialState,
  reducers: {
    subUser: (state, action) => {
      console.log(action,"hey----------")
      state.subUserId = action.payload;
    },
  },
});
export const { subUser } = SubUserSlice.actions;
export default SubUserSlice.reducer;
